import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';

export const GroupTag = ({ children }: React.PropsWithChildren) => (
  <Box
    borderRadius="full"
    display="flex"
    alignItems="center"
    justifyContent="center"
    bg="textDisabled"
    py="space3"
    px="space4"
  >
    <Text fontSize="125" fontWeight="semiBold" color="text" lineHeight="none">
      {children}
    </Text>
  </Box>
);
